import React from 'react';
import './DetailsExtraImg.css';

const ExtraImg = (props) => {
    return ( 
        <>
        <img className={props.extraImgStyle} src={props.extraImg} alt="alternative imgs" />
        </>
     );
}
 
export default ExtraImg;